import { Component } from "@angular/core";
import { HubRecordEditorBase } from "../_hub_record_editor_base";

enum tabs {
    workdayProjects,
    estimatedFinancials,
    notes
}

@Component({
    selector: "app-financials-edit-container",
    templateUrl: "./financials-edit-container.component.html",
    styleUrls: ["./financials-edit-container.component.scss"],
    standalone: false,
})
export class FinancialsEditContainerComponent extends HubRecordEditorBase {
    public tabs = tabs;
    activeTab: tabs = tabs.workdayProjects;

    public setTabTo(tab: tabs, $e): void {
        this.activeTab = tab;
        $e.preventDefault();
    }
}
